module.exports = ".archive{width:2.5rem;height:2rem;cursor:pointer;right:0}"